<div class="tabs" [ngClass]="[(tabsMode === 'classic' && 'tabs--classic') || '', orientation, vAlignment, hAlignment]">
  <ul class="tabs__list" role="tablist" [class.fill-space]="fillSpace">
    <li class="tabs__item" *ngFor="let tab of tabs; index as i">
      <button
        class="tabs__tab"
        role="tab"
        type="button"
        [attr.aria-controls]="'tab-panel-' + i"
        [attr.aria-selected]="tab.selected"
        [id]="'tab-' + i"
        [disabled]="tab.disabled"
        (click)="selectTab(tab)"
      >
        <span class="text-ellipsis" [tooltip]="tab.label" [overflowOnly]="true" [style.max-width]="tab.maxWidth">{{
          tab.label
        }}</span>
        <button
          class="tabs__close button button--icon button--icon-transparent"
          type="button"
          *ngIf="removableTabs"
          [attr.aria-controls]="'tab-panel-' + i"
          (click)="closeTab(tab)"
        >
          <svg-icon
            name="ico-close-16"
            [svgStyle]="{ 'width.px': 12, 'height.px': 12, fill: 'currentColor' }"
          ></svg-icon>
        </button>
      </button>
    </li>
  </ul>

  <div class="tabs__panel-group">
    <ng-content></ng-content>
  </div>
</div>
